import axios from 'axios';

import { API_BASE_URL } from '../api';
import { auth } from '../firebase/firebase';

export const createChat = async () => {
  try {
    const token = await auth.currentUser?.getIdToken();
    const response = await axios.post(
      `${API_BASE_URL}/api/chat`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error('Error creating chat:', error);
    return null;
  }
};

export const createChatWithMessage = async (message: string) => {
  try {
    const token = await auth.currentUser?.getIdToken();
    const response = await axios.post(
      `${API_BASE_URL}/api/chat`,
      { message },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error('Error creating chat with message:', error);
    return null;
  }
};

export const getQuickPrompts = async () => {
  try {
    const token = await auth.currentUser?.getIdToken();
    const response = await axios.get(`${API_BASE_URL}/api/chat/quick-prompts`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching quick prompts:', error);
    return [];
  }
};

export const getChatByProject = async (taskManager: string, projectId: string, projectName?: string) => {
  try {
    const idToken = await auth.currentUser?.getIdToken();
    const response = await axios.get(`${API_BASE_URL}/api/chat/project/${taskManager}/${projectId}`, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });
    if (!response.data || !response.data?.chatId) {
      return createChatByIntegratedProject(taskManager, projectId, projectName || '');
    }

    return response.data;
  } catch (error) {
    console.error('Error fetching chat by project:', error);
    return null;
  }
};

export const createChatByIntegratedProject = async (taskManager: string, projectId: string, projectName: string) => {
  try {
    const idToken = await auth.currentUser?.getIdToken();
    const response = await axios.post(
      `${API_BASE_URL}/api/chat/project/${taskManager}/${projectId}`,
      {
        projectName,
        taskManager,
        projectId,
      },
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error('Error creating chat:', error);
  }
};

// Функция для удаления чата
export const deleteChat = async (chatId: string) => {
  try {
    const token = await auth.currentUser?.getIdToken();
    await axios.delete(`${API_BASE_URL}/api/chat/${chatId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error('Error deleting chat:', error);
  }
};
export const syncProjects = async () => {
  const idToken = await auth.currentUser?.getIdToken();
  const response = await axios.get(`${API_BASE_URL}/api/integrations/sync`, {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  });

  return response.data;
};

export const fetchChatList = async (pagination: { page: number; limit?: number }) => {
  try {
    const token = await auth.currentUser?.getIdToken();
    const response = await axios.get(`${API_BASE_URL}/api/chat`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: pagination,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching chat list:', error);
    return [];
  }
};

export const fetchChat = async (chatId: string) => {
  try {
    const idToken = await auth.currentUser?.getIdToken();
    const response = await axios.get(`${API_BASE_URL}/api/chat/${chatId}`, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching chat:', error);
    return null;
  }
};
